module.exports = __webpack_public_path__ + "img/shoporamaicon.95447664.svg";